import * as Rating from './Rating';

export default Rating;
